import { Navigate, useParams } from "react-router-dom";

// 旧流程链接统一到可补填资料的收据页；不再通过查询参数写入邮寄选项。
export default function DonationHistory() {
  const { campaignId, donationId } = useParams();
  return (
    <Navigate
      to={`/donation/${campaignId}/amount/receipt/${donationId}`}
      replace
    />
  );
}
